
import YouTubeLink from "@/components/YouTubeLink";

const VideoIntroSection = () => {
  return (
    <section className="py-12 bg-white">
      <div className="container max-w-4xl mx-auto">
        <div className="text-center mb-8">
          <h2 className="text-2xl font-semibold text-joerg-800">Entdecken Sie meine Coaching-Philosophie</h2>
          <p className="mt-2 text-joerg-600">Ein kurzer Einblick in meine Arbeitsweise und Werte</p>
        </div>
        <YouTubeLink 
          youtubeId="o9OqMvz2wNA" 
          title="Jörg Hörmann - Coaching Philosophie"
          description="In meinem Video erhalten Sie Einblicke in meine persönliche Reise und berufliche Philosophie, die von unstillbarer Neugier, Naturverbundenheit und dem tiefen Wunsch nach stetiger Weiterentwicklung geprägt ist."
          className="mx-auto shadow-elevation"
          aspectRatio="16/9"
        />
      </div>
    </section>
  );
};

export default VideoIntroSection;
